import A11yDialog from 'a11y-dialog'
$('.modal-container').each(function(){
    var id = $(this).attr('id');
    var container = document.getElementById(id)
    var dialog = new A11yDialog(container)
    dialog.on('show', function (element, event) {
        if ($('.slider-for').length) {
            $('.slider-for')[0].slick.refresh();
            $('.slider-for').slick('setPosition');
        }
        if ($('.slider-nav').length) {
            $('.slider-nav')[0].slick.refresh();
            $('.slider-nav').slick('setPosition');
        }
    })
})